import { Pipeline, PipelineSteps } from "../../models/tasks";

export const message_map: Record<Pipeline, Record<PipelineSteps, string>> = {
  [Pipeline.LUNGS_REPORT]: {
    [PipelineSteps.SUBMITTED]: "Image submission",
    [PipelineSteps.CONVERTED]: "Image conversion",
    [PipelineSteps.SEGMENTED]: "Organs segmentation",
    [PipelineSteps.EXTRACTED]: "Features extraction",
    [PipelineSteps.RENDERED]: "Report render",
  },
  [Pipeline.NODULES]: {
    [PipelineSteps.SUBMITTED]: "Image submission",
    [PipelineSteps.CONVERTED]: "Image conversion",
    [PipelineSteps.SEGMENTED]: "Nodules scanning",
    [PipelineSteps.EXTRACTED]: "Features extraction",
    [PipelineSteps.RENDERED]: "Report render",
  },
  [Pipeline.BATCH]: {
    [PipelineSteps.SUBMITTED]: "Image submission",
    [PipelineSteps.CONVERTED]: "Image conversion",
    [PipelineSteps.SEGMENTED]: "Organs segmentation",
    [PipelineSteps.EXTRACTED]: "Features extraction",
    [PipelineSteps.RENDERED]: "Report render",
  },
};

export const next_message_map: Record<Pipeline, Record<PipelineSteps, string>> = {
  [Pipeline.LUNGS_REPORT]: {
    [PipelineSteps.SUBMITTED]: message_map[Pipeline.LUNGS_REPORT][PipelineSteps.CONVERTED],
    [PipelineSteps.CONVERTED]: message_map[Pipeline.LUNGS_REPORT][PipelineSteps.SEGMENTED],
    [PipelineSteps.SEGMENTED]: message_map[Pipeline.LUNGS_REPORT][PipelineSteps.EXTRACTED],
    [PipelineSteps.EXTRACTED]: message_map[Pipeline.LUNGS_REPORT][PipelineSteps.RENDERED],
    [PipelineSteps.RENDERED]: "Completed",
  },
  [Pipeline.NODULES]: {
    [PipelineSteps.SUBMITTED]: message_map[Pipeline.NODULES][PipelineSteps.CONVERTED],
    [PipelineSteps.CONVERTED]: message_map[Pipeline.NODULES][PipelineSteps.SEGMENTED],
    [PipelineSteps.SEGMENTED]: message_map[Pipeline.NODULES][PipelineSteps.EXTRACTED],
    [PipelineSteps.EXTRACTED]: message_map[Pipeline.NODULES][PipelineSteps.RENDERED],
    [PipelineSteps.RENDERED]: "Completed",
  },
  [Pipeline.BATCH]: {
    [PipelineSteps.SUBMITTED]: message_map[Pipeline.BATCH][PipelineSteps.CONVERTED],
    [PipelineSteps.CONVERTED]: message_map[Pipeline.BATCH][PipelineSteps.SEGMENTED],
    [PipelineSteps.SEGMENTED]: message_map[Pipeline.BATCH][PipelineSteps.EXTRACTED],
    [PipelineSteps.EXTRACTED]: message_map[Pipeline.BATCH][PipelineSteps.RENDERED],
    [PipelineSteps.RENDERED]: "Completed",
  },
};
